import React from 'react';
import { KoobPill } from './KoobPill';
import KoobTooltip from './KoobTooltip';

type KoobPillAddProps = Omit<
  React.ComponentProps<typeof KoobPill>,
  'onRemove'
> & {
  /** Tooltip explaining why adding is disabled; shown only while disabled. */
  disabledTip?: React.ReactNode;
};

const KoobPillAdd = React.forwardRef<HTMLButtonElement, KoobPillAddProps>(
  ({ disabledTip, children, ...props }, ref) => (
    <KoobTooltip disabled={!props.disabled} tip={disabledTip}>
      <KoobPill ref={ref} {...props}>
        <i className="fa-light fa-circle-plus" />
        {children}
      </KoobPill>
    </KoobTooltip>
  ),
);
KoobPillAdd.displayName = 'KoobPillAdd';

export { KoobPillAdd };
